module.exports = __webpack_public_path__ + "img/heart_structureFunction_summary_bj.1cb76201.png";